import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/Home.vue'
import Index from   './views/index/index.vue'
import Service_education from './views/service_education/service_education.vue'
import Contact_us from './views/contact_us/contact_us.vue'
import New from './views/new/new.vue'
import New_info from './views/new_info/new_info.vue'
import About from './views/About/About.vue'
import forwarder from './views/forwarder/forwarder.vue'
import trade from './views/trade/trade.vue'
import personnel from './views/personnel/personnel.vue'

import test from './views/test.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children:[
        {
        // 首页
        path:'/',
        component:Index
      },
      {
        // 产品服务
        path:'/Service_education',
        component:Service_education
      },
      {
        // 货代
        path:'/forwarder',
        component:forwarder
      },
      {
        // 外贸
        path:'/trade',
        component:trade
      },
      {
        // 人才
        path:'/personnel',
        component:personnel
      },
      {
        // 联系我们
        path:'/Contact_us',
        component:Contact_us
      },
      {
        //新闻中心
        path:'/New',
        component:New
      },
      {
        //新闻详情
        path:'/New_info',
        component:New_info
      },
      {
        //关于我们
        path:'/About',
        component:About
      },
      {
        path:'/test',
        component:test
      },
      ]
    },

  ]
})
